// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Tag.module.scss  */
.Tag-module-Root_3mI {
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  order: 1;
  box-sizing: border-box; }
  .Tag-module-Root_3mI > :last-child {
    padding-right: 0.5rem; }
  .Tag-module-Root_3mI_disabled {
    user-select: none;
    pointer-events: none; }
  .Tag-module-Root_3mI[aria-hidden='true'] {
    visibility: hidden;
    clip: rect(0 0 0 0);
    order: 3;
    padding: 0;
    white-space: nowrap;
    border: 0;
    clip-path: inset(100%); }

.Tag-module-Label_2i0 {
  overflow: hidden;
  flex-shrink: 1;
  margin-left: 0.5rem;
  font-family: var(--tag-font-family);
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none; }

.Tag-module-AddonBefore_3KM,
.Tag-module-AddonAfter_1bF {
  flex-shrink: 0;
  margin-left: 0.5rem;
  fill: inherit; }

.Tag-module-ActionRemove_3Oj {
  padding-left: 0.5rem; }

.Tag-module-ActionPrimary_1kA {
  overflow: hidden;
  color: inherit; }

.Tag-module-ActionPrimary_1kA,
.Tag-module-ActionRemove_3Oj {
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  border: 0;
  background-color: transparent; }
  .Tag-module-ActionPrimary_1kA:hover,
  .Tag-module-ActionRemove_3Oj:hover {
    transition: background-color 0.2s ease-out; }

.Tag-module-IconRemove_2XB {
  pointer-events: none; }

.Tag-module-mSize_1tH {
  height: var(--tag-height);
  border-radius: var(--tag-border-radius); }

.Tag-module-mSize_1tH .Tag-module-Label_2i0 {
  font-size: var(--tag-font-size);
  line-height: var(--tag-line-height); }

.Tag-module-defaultTheme_yWz {
  color: var(--tag-color-default);
  border: 1px solid var(--tag-border-color-default);
  background-color: var(--tag-border-color-default);
  fill: var(--tag-color-default); }
  .Tag-module-defaultTheme_yWz .Tag-module-ActionRemove_3Oj {
    fill: var(--tag-color-default); }
  .Tag-module-defaultTheme_yWz .Tag-module-ActionPrimary_1kA:hover, .Tag-module-defaultTheme_yWz .Tag-module-ActionPrimary_1kA:focus,
  .Tag-module-defaultTheme_yWz .Tag-module-ActionRemove_3Oj:hover,
  .Tag-module-defaultTheme_yWz .Tag-module-ActionRemove_3Oj:focus {
    outline: 0;
    background-color: var(--tag-background-default-hover); }
  .Tag-module-defaultTheme_yWz.Tag-module-hasAction_2Ug {
    color: var(--tag-color-link);
    border-color: var(--tag-border-color-link);
    background-color: var(--tag-border-color-link);
    fill: var(--tag-color-link); }
  .Tag-module-defaultTheme_yWz.Tag-module-checked_1zp {
    color: var(--tag-color-default-checked);
    border-color: var(--tag-color-default-checked);
    fill: var(--tag-color-default-checked); }
  .Tag-module-defaultTheme_yWz.Tag-module-disabled_Mwo {
    pointer-events: none;
    color: var(--tag-color-default-disabled);
    border-color: var(--tag-color-default-disabled);
    fill: var(--tag-color-default-disabled); }

.Tag-module-outlinedVariant_3QN,
.Tag-module-outlinedVariant_3QN.Tag-module-hasAction_2Ug {
  background-color: var(--color-background-base); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Tag/Tag.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB,EAAE;EACxB;IACE,qBAAqB,EAAE;EACzB;IACE,iBAAiB;IACjB,oBAAoB,EAAE;EACxB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,sBAAsB,EAAE;;AAE5B;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB,EAAE;;AAExB;;EAEE,cAAc;EACd,mBAAmB;EACnB,aAAa,EAAE;;AAEjB;EACE,oBAAoB,EAAE;;AAExB;EACE,gBAAgB;EAChB,cAAc,EAAE;;AAElB;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,6BAA6B,EAAE;EAC/B;;IAEE,0CAA0C,EAAE;;AAEhD;EACE,oBAAoB,EAAE;;AAExB;EACE,yBAAyB;EACzB,uCAAuC,EAAE;;AAE3C;EACE,+BAA+B;EAC/B,mCAAmC,EAAE;;AAEvC;EACE,+BAA+B;EAC/B,iDAAiD;EACjD,iDAAiD;EACjD,8BAA8B,EAAE;EAChC;IACE,8BAA8B,EAAE;EAClC;;;IAGE,UAAU;IACV,qDAAqD,EAAE;EACzD;IACE,4BAA4B;IAC5B,0CAA0C;IAC1C,8CAA8C;IAC9C,2BAA2B,EAAE;EAC/B;IACE,uCAAuC;IACvC,8CAA8C;IAC9C,sCAAsC,EAAE;EAC1C;IACE,oBAAoB;IACpB,wCAAwC;IACxC,+CAA+C;IAC/C,uCAAuC,EAAE;;AAE7C;;EAEE,8CAA8C,EAAE","sourcesContent":["/*  imported from Tag.module.scss  */\n.Tag-module-Root_3mI {\n  display: inline-flex;\n  overflow: hidden;\n  align-items: center;\n  order: 1;\n  box-sizing: border-box; }\n  .Tag-module-Root_3mI > :last-child {\n    padding-right: 0.5rem; }\n  .Tag-module-Root_3mI_disabled {\n    user-select: none;\n    pointer-events: none; }\n  .Tag-module-Root_3mI[aria-hidden='true'] {\n    visibility: hidden;\n    clip: rect(0 0 0 0);\n    order: 3;\n    padding: 0;\n    white-space: nowrap;\n    border: 0;\n    clip-path: inset(100%); }\n\n.Tag-module-Label_2i0 {\n  overflow: hidden;\n  flex-shrink: 1;\n  margin-left: 0.5rem;\n  font-family: var(--tag-font-family);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  pointer-events: none; }\n\n.Tag-module-AddonBefore_3KM,\n.Tag-module-AddonAfter_1bF {\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n  fill: inherit; }\n\n.Tag-module-ActionRemove_3Oj {\n  padding-left: 0.5rem; }\n\n.Tag-module-ActionPrimary_1kA {\n  overflow: hidden;\n  color: inherit; }\n\n.Tag-module-ActionPrimary_1kA,\n.Tag-module-ActionRemove_3Oj {\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  padding: 0;\n  cursor: pointer;\n  text-decoration: none;\n  border: 0;\n  background-color: transparent; }\n  .Tag-module-ActionPrimary_1kA:hover,\n  .Tag-module-ActionRemove_3Oj:hover {\n    transition: background-color 0.2s ease-out; }\n\n.Tag-module-IconRemove_2XB {\n  pointer-events: none; }\n\n.Tag-module-mSize_1tH {\n  height: var(--tag-height);\n  border-radius: var(--tag-border-radius); }\n\n.Tag-module-mSize_1tH .Tag-module-Label_2i0 {\n  font-size: var(--tag-font-size);\n  line-height: var(--tag-line-height); }\n\n.Tag-module-defaultTheme_yWz {\n  color: var(--tag-color-default);\n  border: 1px solid var(--tag-border-color-default);\n  background-color: var(--tag-border-color-default);\n  fill: var(--tag-color-default); }\n  .Tag-module-defaultTheme_yWz .Tag-module-ActionRemove_3Oj {\n    fill: var(--tag-color-default); }\n  .Tag-module-defaultTheme_yWz .Tag-module-ActionPrimary_1kA:hover, .Tag-module-defaultTheme_yWz .Tag-module-ActionPrimary_1kA:focus,\n  .Tag-module-defaultTheme_yWz .Tag-module-ActionRemove_3Oj:hover,\n  .Tag-module-defaultTheme_yWz .Tag-module-ActionRemove_3Oj:focus {\n    outline: 0;\n    background-color: var(--tag-background-default-hover); }\n  .Tag-module-defaultTheme_yWz.Tag-module-hasAction_2Ug {\n    color: var(--tag-color-link);\n    border-color: var(--tag-border-color-link);\n    background-color: var(--tag-border-color-link);\n    fill: var(--tag-color-link); }\n  .Tag-module-defaultTheme_yWz.Tag-module-checked_1zp {\n    color: var(--tag-color-default-checked);\n    border-color: var(--tag-color-default-checked);\n    fill: var(--tag-color-default-checked); }\n  .Tag-module-defaultTheme_yWz.Tag-module-disabled_Mwo {\n    pointer-events: none;\n    color: var(--tag-color-default-disabled);\n    border-color: var(--tag-color-default-disabled);\n    fill: var(--tag-color-default-disabled); }\n\n.Tag-module-outlinedVariant_3QN,\n.Tag-module-outlinedVariant_3QN.Tag-module-hasAction_2Ug {\n  background-color: var(--color-background-base); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
